import MasterTeachersModel from '../Apis/MasterTeachers.js'
import Controller from './Controller.js';
import Swal from 'sweetalert2'

export default class MasterTeachersController extends Controller {

    constructor() {
        super(new MasterTeachersModel());
    }
    async MakeSupervisor(params) {
        const res = await this.model.MakeSupervisor(params);
        return this.Poup(res);

    }
    async Masters(params) {
        const response =await this.model.Masters(params);
        return response
    }
    async getRole(current_user_id,masterId) {
        const response =await this.model.getRole(current_user_id,masterId);
        return response
    }
    async getGeneralRole(current_user_id) {
        const response =await this.model.getGeneralRole(current_user_id);
        return response
    }

}